<ng-template #cookiesModal let-modal>
        <div class="modal-header">
            <h1 class="modal-title" id="modal1Label">{{ cookiesTextTitle }}</h1>
            <button (click)="hideCookieModal()" type="button" data-dismiss="modal" class="btn btn--close btn--icon-only">
                <svg class="svg-icon svg-close" aria-hidden="true" focusable="false">
                    <use xlink:href="../../../assets/svg-icons/icon-sprite.svg#close"></use>
                </svg>
                <span class="sr-only"></span>
            </button>
        </div>
        <div class="modal-body">
            <br/>
            {{ 'cookies.firstParagraph' | translate }}
            <br/><br/>
            {{ cookiesTextP2 }}
        </div>
        <div class="modal-footer">
            <button #acceptCookieButton class="btn btn--plain btn--primary" type="button" id="cookiesButton" (click)="onAccept()">
                {{ cookiesTextButton }}
            </button>
        </div>
</ng-template>
